import React from 'react';
import DataProviderTableRow from './DataProviderTableRow';
import {
  Table,
  TableBody,
  TableDiv,
  TableHead,
  TableHeadCell,
  TableHeadRow,
} from '../style';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import ROUTE_PATH from '../../../../../routes/config';
import { useNavigate } from 'react-router-dom';

const DataProviderTable = ({ tableHead, dataProviderList, tableDataType }) => {
  const navigate = useNavigate();
  const mallSeqList = dataProviderList?.map(mall => mall?.mallSeq);
  return (
    <TableDiv>
      <Table>
        <TableHead>
          <TableHeadRow>
            {tableHead.map((item, index) => {
              return (
                <TableHeadCell key={index} type={tableDataType}>
                  {item}
                </TableHeadCell>
              );
            })}
          </TableHeadRow>
        </TableHead>
        <TableBody>
          {dataProviderList && dataProviderList.length > 0 ? (
            dataProviderList.map((item, index) => {
              // 중복으로 등록된 몰일 경우 아이디를 추가로 노출
              const isDuplicatedMall =
                mallSeqList?.filter(mallSeq => mallSeq === item?.mallSeq)
                  ?.length > 1;
              return (
                <DataProviderTableRow
                  key={`dataProviderTableRow_${
                    item.dataProviderSeq || item.mallSeq || 'index'
                  }_${index}`}
                  item={item}
                  type={tableDataType}
                  isDuplicatedMall={isDuplicatedMall}
                />
              );
            })
          ) : (
            <tr className={'no-list'}>
              <td colSpan={3}>
                연동이 완료된 판매몰이 없습니다.
                <br />
                판매몰 연동을 먼저 진행해 주세요.
                <br />
                <button
                  type={'button'}
                  onClick={() => navigate(ROUTE_PATH.mypage.dataLinkageManage)}
                >
                  데이터 연동하기{' '}
                  <FeatherIcon
                    icon="external-link"
                    size={12}
                    stroke="#02A4FF"
                    strokeWidth={2}
                  />
                </button>
              </td>
            </tr>
          )}
        </TableBody>
      </Table>
    </TableDiv>
  );
};

export default DataProviderTable;
